import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { AppIcon } from './ui/icon'
import { mdiMapMarker, mdiPencil } from '@mdi/js'
import { formatIso20022Address } from '../lib/format-address'

interface AddressCompactDisplayProps {
    addressIso20022: Record<string, any> | null
    addressRaw: string | null
    onEdit?: () => void
    className?: string
}

export function AddressCompactDisplay({
    addressIso20022,
    addressRaw,
    onEdit,
    className = '',
}: AddressCompactDisplayProps) {
    const { t } = useTranslation('assets')

    const displayText = useMemo(() => {
        if (addressIso20022 && typeof addressIso20022 === 'object') {
            return formatIso20022Address(addressIso20022)
        }
        if (addressRaw) return addressRaw
        return null
    }, [addressIso20022, addressRaw])

    return (
        <div
            className={`group flex items-start gap-1.5 cursor-pointer rounded-md px-2 py-1 hover:bg-muted/50 transition-colors ${className}`}
            onClick={onEdit}
            data-testid="address-compact-display"
            title={onEdit ? t('detail.edit_address') : undefined}
        >
            <AppIcon tone="muted" path={mdiMapMarker} size="xs" className="mt-0.5 flex-shrink-0" />
            {displayText ? (
                <span className="text-sm text-foreground leading-tight">{displayText}</span>
            ) : (
                <span className="text-sm text-muted-foreground italic">{t('detail.no_address')}</span>
            )}
            {onEdit && (
                <AppIcon tone="muted" path={mdiPencil} size="xs" className="mt-0.5 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" data-testid="address-compact-edit-btn" />
            )}
        </div>
    )
}
